import { Button, Card, Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { Link } from "react-router-dom";
import { infEmbCombInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus } from "../../../utils/utils";
import { addComboio, removeComboio } from "../../../features/manifestoSlice";

const LIMITE: number = 30;

const initialState: infEmbCombInterface = {
    id: 0,
    cembcomb: '',
    xbalsa: ''
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function EmbarcacaoComboio() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infEmbComb);
    const [form, setForm] = useState<infEmbCombInterface>(initialState);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const codEmbarcacao = useRef<HTMLInputElement>(null)
    const nomeBalsa = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.cembcomb.toString() === "") {
            alerta('Informe o Código da Embarcação');
            goToFocus(codEmbarcacao);
            return false;
        }

        if (form.xbalsa.toString() === "") {
            alerta('Informe o nome da balsa');
            goToFocus(nomeBalsa);
            return false;
        }

        if (lista.length >= LIMITE) {
            alerta(`Limite de ${formatMoeda(LIMITE, 0)} terminais atingido.`);
            return false;
        }

        if (lista.find((item: infEmbCombInterface) => item.cembcomb.trim() === form.cembcomb.trim())) {
            alerta('Código da embarcação já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addComboio({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(codEmbarcacao);
        }
    }

    const handleRemover = (id: number) => {
        dispatch(removeComboio(id));
        setShowModal(false);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>Informações dos terminais de carregamento <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Código da Embarcação</Form.Label>
                            <Form.Control type="text" name="cembcomb" maxLength={10} value={form.cembcomb}
                                ref={codEmbarcacao}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>Identificador da Balsa</Form.Label>
                            <Form.Control type="text" name="xbalsa" maxLength={60} value={form.xbalsa}
                                ref={nomeBalsa}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />  Adicionar
                        </Button>
                    </Col>
                </JRow>

                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center" style={{ width: '4rem' }}>#</th>
                            <th className="text-center" style={{ width: '11rem' }}>Cód. Embarcação</th>
                            <th className="text-center" >Identificador da Balsa</th>
                        </tr>
                    </thead>

                    <tbody>
                        {lista?.map((item: infEmbCombInterface) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger"
                                        onClick={() => handleOpenModal({ id: item.id, title: item.xbalsa })}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Link>
                                </td>
                                <td className="text-center">{item.cembcomb}</td>
                                <td className="text-center">{item.xbalsa}</td>

                            </tr>
                        ))}
                    </tbody>
                </Table>

            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}